import { Skeleton } from '@arcadiapower/shrike';
import { ImageSelector, TERMS_IMAGE } from '~/components/image';
import { Container, TwoColumnGrid } from '~/components/layout';
import { SolarTerms } from '~/components/terms/solar-terms';
import { Text, Title, Description } from '~/components/typography';
import { ReviewAndViewTermsProps } from '../review-and-view-terms.wrapper';
import { EditUserWrapper } from './edit-user/edit-user.wrapper';
import { ProofDocDisplayWrapper } from './proof-doc-display/proof-doc-display.wrapper';
import { reviewAndViewTermsCopy } from './review-and-view-terms.copy';
import { Spacer, StyledSeparator } from './review-and-view-terms.style';

export const ReviewAndViewTerms = (props: ReviewAndViewTermsProps) => {
  const { step, title, description, descriptionSponsoredSolar } = reviewAndViewTermsCopy;
  const {
    contracts,
    flags,
    funnelPacket,
    error,
    loading,
    onSubmitSolarTerms,
    pending,
    originationSourceType,
    utilityAccountId,
  } = props;
  const isSponsoredSolar =
    funnelPacket?.user?.originationSource?.originationSourceType === 'sponsored_solar';

  return (
    <TwoColumnGrid testId="screen-VnmTerms">
      <TwoColumnGrid.Primary>
        <Text color="secondary" fontWeight="700" fontSize="16px">
          {step}
        </Text>
        <Title margin="24px 0">{title}</Title>
        <Description mb={4}>
          {isSponsoredSolar ? descriptionSponsoredSolar : description}
        </Description>
        {error ? null : (
          <>
            <Container>
              {loading ? (
                <Skeleton
                  data-testid="skeleton-component"
                  backgroundColor="tertiary"
                  width="100%"
                />
              ) : (
                <>
                  <EditUserWrapper funnelPacket={funnelPacket} />
                  <StyledSeparator />
                  <ProofDocDisplayWrapper funnelPacket={funnelPacket} />
                </>
              )}
            </Container>
            <Spacer />
          </>
        )}
        <SolarTerms
          canSubmit
          contracts={contracts?.vnmSolarProjectContracts ?? []}
          copy={reviewAndViewTermsCopy}
          error={error?.message}
          loading={loading}
          onSubmit={onSubmitSolarTerms}
          pending={pending}
          originationSourceType={originationSourceType}
          utilityAccountId={utilityAccountId}
          showPersonalizedContractPreview={flags.showPersonalizedContractPreview}
        />
      </TwoColumnGrid.Primary>
      <TwoColumnGrid.Secondary>
        <ImageSelector type={TERMS_IMAGE} />
      </TwoColumnGrid.Secondary>
    </TwoColumnGrid>
  );
};
